import * as Query from './eventTriggerSetting.query';
import * as Mutation from './eventTriggerSetting.mutation';

export default { Query, Mutation };
